export default __webpack_public_path__ + "static/media/record-audio.dd6ecfcb.svg";